import { appraisalSlice } from "./Appraisal";
import { imageUploadSlice } from "./ImageUploads";

const rootReducer = {
  appraisal: appraisalSlice.reducer,
  imageUploads: imageUploadSlice.reducer
};

export default rootReducer;
